import PortfolioItem from '@business/portfolio/PortfolioItem';
import { PortfolioItemType } from '@graphql/generated';
import { useAppStateSelector } from '@redux/hooks';
import SmoothImage from '@xFrame4/components/SmoothImage';
import { FunctionComponent } from 'react';

interface PortfolioItemComponentProps
{
    portfolioItem: PortfolioItem;
}

const PortfolioItemComponent: FunctionComponent<PortfolioItemComponentProps> = (props) =>
{
    const language = useAppStateSelector(state => state.layout.language);
    const translation = props.portfolioItem.getTranslation(language.code);
    
    /** Render */
    return (
        <div className="portfolio-item row mb-5">
            <div className="col-lg-8">
                {translation?.title && <div className="portfolio-item-title fw-bold mb-3">{translation.title}</div>}
                {translation?.subtitle && <div className="portfolio-item-subtitle mb-2" dangerouslySetInnerHTML={{ __html: translation.subtitle }}></div>}

                {props.portfolioItem.type == PortfolioItemType.Image && props.portfolioItem.image &&
                    <SmoothImage 
                        src={props.portfolioItem.image.url}
                        width={props.portfolioItem.image.width}
                        height={props.portfolioItem.image.height}
                        className="portfolio-item-image img-fluid w-100 mb-4 border border-gray-300"
                    />
                }

                {props.portfolioItem.type == PortfolioItemType.Video && props.portfolioItem.videoUrl &&
                    <video controls className="w-100">
                        <source src={props.portfolioItem.videoUrl} type="video/mp4"></source>
                    </video>
                }

                {translation?.title2 && <div className="portfolio-item-title2-1 fw-bold mb-3">{translation.title2}</div>}
                {translation?.subtitle2 && <div className="portfolio-item-subtitle2" dangerouslySetInnerHTML={{ __html: translation.subtitle2 }}></div>}
            </div>
        </div>
    );
}

export default PortfolioItemComponent;